import { render, staticRenderFns } from "./Campaigns.vue?vue&type=template&id=1df51550&scoped=true&"
import script from "./Campaigns.vue?vue&type=script&lang=js&"
export * from "./Campaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df51550",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1df51550')) {
      api.createRecord('1df51550', component.options)
    } else {
      api.reload('1df51550', component.options)
    }
    module.hot.accept("./Campaigns.vue?vue&type=template&id=1df51550&scoped=true&", function () {
      api.rerender('1df51550', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Marketing/Campaigns.vue"
export default component.exports